import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getHomeJsonLd, getArticleJsonLd } from './jsonLd';
import { isArticleRoute, getArticleSlug } from './seoData';

export default function JsonLdManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const jsonLd = isArticleRoute(pathname)
      ? getArticleJsonLd(getArticleSlug(pathname), pathname)
      : getHomeJsonLd();

    document
      .querySelectorAll('script[data-seo-jsonld]')
      .forEach((el) => el.remove());

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-seo-jsonld', 'true');
    script.textContent = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document
        .querySelectorAll('script[data-seo-jsonld]')
        .forEach((el) => el.remove());
    };
  }, [pathname]);

  return null;
}